var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20833 15.5833V6.41658C3.20833 3.66659 4.55583 1.83325 7.7825 1.83325H14.1992C17.38 1.83325 18.7825 3.66659 18.7825 6.41658V14.5108L18.7917 15.5833C18.7917 18.3333 17.3892 20.1666 14.2083 20.1666H7.79167C4.55583 20.1666 3.20833 18.3333 3.20833 15.5833Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32417 20.1391L7.315 17.4166C7.315 16.3991 8.13083 15.5833 9.14833 15.5833H12.8242C13.8325 15.5833 14.6483 16.3991 14.6575 17.4074L14.685 20.1483",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.13159H8.00003",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/devices-icon.56f10eeb1e8f9f7a69bc54626a35f8d9.svg";
export { ForwardRef as ReactComponent };